import styles from "./part3.module.scss";
export default function HomePart2() {
  const listArr = [
    {
      pic: "/img/img_numbers.png",
      title: "Multiple Numbers on One Phone",
      desc: "You can pick a 2nd phone number to separate life and business. Multiple numbers can be used on one phone with Dingtone app applied.",
    },
    {
      pic: "/img/img_earth.png",
      title: "Calling Codes for Multiple Countries",
      desc: "Dingtone provides real phone numbers for US, UK, Canada, Australia, etc. and ones with local area codes to unlimitedly call and text with Internet.",
    },
    {
      pic: "/img/img_features.png",
      title: "Business Phone Features",
      desc: "Dingtone app also provides business phone features to boost business through calling such as voicemail, call forwarding, block call, etc.",
    },
  ];
  return (
    <div className={styles.part3 + " main"}>
      <div className={styles.inner + " flex-r"}>
        <div className={styles.left}>
          <h5>Pick a Number to Register Online</h5>
          <h2>Protect Your Private Number</h2>
          <p>
            Best protect your number with a 2nd phone number for registration
            verification on apps and sites. Give your private number ONLY to
            those you trust.
          </p>
        </div>
        <div className={styles.right}>
          <img src="/img/img_words.png" alt="Protect Your Private Number" />
        </div>
      </div>
    </div>
  );
}
